import React from 'react'
import { useI18n } from '../i18n/I18nProvider'

function MultiPlantToolbar({
  selectedMode,
  waterLevel,
  onModeClick,
  onZoomButton,
  onRequestPublish,
  showToolHint,
  hideToolHint,
  handleToolTouchStart,
  handleToolTouchEnd,
  hasPruner = true,
  hasPlants = true,
  canPublish = true,
  waterCooldownText = null,
}) {
  const { t } = useI18n()
  return (
    <div
      className="absolute z-10 flex gap-2 bg-white/80 rounded-lg p-2 shadow-lg
                 top-1/2 right-2 -translate-y-1/2 flex-col
                 md:top-4 md:right-4 md:left-auto md:bottom-auto md:translate-y-0 md:flex-col"
    >
      {/* Contrôles de zoom pour desktop */}
      <div className="hidden md:flex flex-col gap-1 mb-1">
        <button
          type="button"
          onClick={() => onZoomButton('out')}
          onMouseEnter={() => showToolHint('zoomOut')}
          onMouseLeave={hideToolHint}
          className="w-10 h-8 rounded bg-white border border-gray-400 flex items-center justify-center text-xs font-bold"
        >
          🔍-
        </button>
        <button
          type="button"
          onClick={() => onZoomButton('in')}
          onMouseEnter={() => showToolHint('zoomIn')}
          onMouseLeave={hideToolHint}
          className="w-10 h-8 rounded bg-white border border-gray-400 flex items-center justify-center text-xs font-bold"
        >
          🔍+
        </button>
      </div>

      <button
        type="button"
        onClick={() => onModeClick('sun')}
        onMouseEnter={() => showToolHint('sun')}
        onMouseLeave={hideToolHint}
        onTouchStart={() => handleToolTouchStart('sun')}
        onTouchEnd={handleToolTouchEnd}
        onTouchCancel={handleToolTouchEnd}
        disabled={!hasPlants}
        className={`w-10 h-10 rounded ${selectedMode === 'sun' ? 'bg-yellow-400' : 'bg-white'} border border-yellow-500 flex items-center justify-center text-xs font-bold ${!hasPlants ? 'opacity-40 cursor-not-allowed' : ''}`}
      >
        ☀️
      </button>

      <button
        type="button"
        onClick={() => onModeClick('water')}
        disabled={waterLevel < 10 || !hasPlants}
        onMouseEnter={() => showToolHint('water')}
        onMouseLeave={hideToolHint}
        onTouchStart={() => handleToolTouchStart('water')}
        onTouchEnd={handleToolTouchEnd}
        onTouchCancel={handleToolTouchEnd}
        className={`relative w-10 h-10 rounded ${selectedMode === 'water' ? 'bg-blue-400' : 'bg-white'} border border-blue-500 flex items-center justify-center text-xs font-bold ${waterLevel < 10 || !hasPlants ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        💧
        {waterCooldownText && (
          <span className="absolute inset-0 flex items-center justify-center text-[11px] font-black text-red-600 drop-shadow-sm">
            {waterCooldownText}
          </span>
        )}
      </button>

      <button
        type="button"
        onClick={() => onModeClick('hand')}
        onMouseEnter={() => showToolHint('hand')}
        onMouseLeave={hideToolHint}
        onTouchStart={() => handleToolTouchStart('hand')}
        onTouchEnd={handleToolTouchEnd}
        onTouchCancel={handleToolTouchEnd}
        disabled={!hasPlants}
        className={`w-10 h-10 rounded ${selectedMode === 'hand' ? 'bg-gray-300' : 'bg-white'} border border-gray-500 flex items-center justify-center text-xs font-bold ${!hasPlants ? 'opacity-40 cursor-not-allowed' : ''}`}
      >
        ✋
      </button>

      <button
        type="button"
        onClick={() => onModeClick('pruner')}
        onMouseEnter={() => showToolHint('pruner')}
        onMouseLeave={hideToolHint}
        onTouchStart={() => handleToolTouchStart('pruner')}
        onTouchEnd={handleToolTouchEnd}
        onTouchCancel={handleToolTouchEnd}
        disabled={!hasPruner}
        className={`w-10 h-10 rounded ${selectedMode === 'pruner' ? 'bg-green-400' : 'bg-white'} border border-green-600 flex items-center justify-center text-xs font-bold ${!hasPruner ? 'opacity-40 cursor-not-allowed' : ''}`}
      >
        ✂️
      </button>

      <button
        type="button"
        onClick={onRequestPublish}
        onMouseEnter={() => showToolHint('camera')}
        onMouseLeave={hideToolHint}
        onTouchStart={() => handleToolTouchStart('camera')}
        onTouchEnd={handleToolTouchEnd}
        onTouchCancel={handleToolTouchEnd}
        disabled={!canPublish}
        className={`w-10 h-10 rounded bg-white border border-purple-500 flex items-center justify-center text-xs font-bold ${!canPublish ? 'opacity-40 cursor-not-allowed' : ''}`}
      >
        📷
      </button>
    </div>
  )
}

export default MultiPlantToolbar
